import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetAggregatorQRCodeResponse {
  status?: boolean;
  message?: string;
  data?: {
    code?: string;
    link?: string;
    qr?: string;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetAggregatorQRCodeResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getAggregatorQRCodeAsync = createAsyncThunk(
  'aggregatorQRCode',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('aggregator/code', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const aggregatorQRCodeGetSlice = createSlice({
  name: 'aggregatorQRCode/get',
  initialState,
  reducers: {
    resetGetAggregatorQRCode: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAggregatorQRCodeAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getAggregatorQRCodeAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetAggregatorQRCodeResponse;
      })
      .addCase(getAggregatorQRCodeAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetAggregatorQRCodeResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetAggregatorQRCode } = aggregatorQRCodeGetSlice.actions;

export default aggregatorQRCodeGetSlice.reducer;
